import { render, staticRenderFns } from "./WebseiteAnmeldungen.vue?vue&type=template&id=2a3768d7&"
import script from "./WebseiteAnmeldungen.vue?vue&type=script&lang=js&"
export * from "./WebseiteAnmeldungen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports